////////////////////////////////////////////////////////////////////////////////
//
// Auth API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const auth = {
    /**
     * Login with credentials
     * @param credentials
     * @returns {Promise<AxiosResponse<any>>}
     */
    login: (credentials) => ApiService.post("login", credentials),
    /**
     * Refresh access token using refresh token
     * @param refreshToken
     * @returns {Promise<AxiosResponse<any>>}
     */
 // In auth.js (API module)
refreshToken: (refreshToken) => {
 //console.log('DEBUG: Making refresh token API call');
  // Create a custom request with the refresh token in the header
  return ApiService.customRequest({
    url: "/refresh",
    method: "post",
    data: {}, // Empty body since we're sending token in header
    headers: {
      "Authorization": `Bearer ${refreshToken}`
    },
    silent: true,
    skipAuthRefresh: true
  });
},
    /**
     * Get account object for username
     * @param username
     * @param entity
     * @returns {Promise<AxiosResponse<any>>}
     */
    getAccount: (username, entity) => {
        if(entity === '__landlord__entity') {
            return ApiService.get(`account/${username}`)
        } else {
            return ApiService.getT(`account/${username}`)
        }
    },
}

export default auth;